import apiService from "./api";

export function sendErrorApiCall(errorStack, errorMessage, client_id, user_id) {
  return apiService.post(`/webapp-error`, {
    error: { stack: errorStack, message: errorMessage },
    client_id,
    user_id
  });
}
